import React from "react";

import { createRoot } from 'react-dom/client';
import PlansContainer from "./plans/PlansContainer";
import * as Sentry from "@sentry/browser";

Sentry.init({
  dsn: "https://0a27033f897e4f1cabaf6ef2cd95c193@o127869.ingest.sentry.io/5770999",
});

export const startProject = () => {
  console.log("plans root is starting");
};

document.addEventListener("DOMContentLoaded", () => {
  console.log("document has loaded");
   const container = document.getElementById('root');
   const root = createRoot(container);
     root.render(<PlansContainer />);
  //render(, document.getElementById("root"));
});
